export const BallHalf = ({ top }) => (
  <svg viewBox="0 0 200 104" className="w-full block">
    <defs><linearGradient id="ball-top" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#8A5CD6" /><stop offset="1" stopColor="#5A2F9E" /></linearGradient></defs>
    {top ? (
      <g><path d="M4 100A96 96 0 0 1 196 100Z" fill="url(#ball-top)" stroke="#F2C230" strokeWidth="5" />
        <rect x="4" y="92" width="192" height="8" fill="#F2C230" />
        <path d="M72 100A28 28 0 0 1 128 100Z" fill="#120E1F" stroke="#F2C230" strokeWidth="5" />
        <path d="M86 100A14 14 0 0 1 114 100Z" fill="#C9B6F2" /></g>
    ) : (
      <g><path d="M4 4A96 96 0 0 0 196 4Z" fill="#120E1F" stroke="#F2C230" strokeWidth="5" />
        <rect x="4" y="4" width="192" height="8" fill="#F2C230" />
        <path d="M72 4A28 28 0 0 0 128 4Z" fill="#120E1F" stroke="#F2C230" strokeWidth="5" />
        <path d="M86 4A14 14 0 0 0 114 4Z" fill="#C9B6F2" /></g>
    )}
  </svg>
);
